import { render, staticRenderFns } from "./Solve.vue?vue&type=template&id=3ce42a52&scoped=true&"
import script from "./Solve.vue?vue&type=script&lang=ts&"
export * from "./Solve.vue?vue&type=script&lang=ts&"
import style0 from "./Solve.vue?vue&type=style&index=0&id=3ce42a52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce42a52",
  null
  
)

export default component.exports